import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Input, InputNumber, Select, Checkbox, Tooltip, Typography, message, DatePicker } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';
import { dateFormat } from '../utils';
import { composeSelectOptions } from '../utils/ComponentUtils';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

function UpdateTournament(props) {
    const [form] = Form.useForm();
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [tournamentTypes, setTournamentsTypes] = useState([]);
    const [isActive,setIsActive] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const { t } = useTranslation();
    // console.warn('props di UpdateTournament:', props);

    useEffect(() => {
        fetch(api.tournaments().listTypes().href)
            .then(res => res.json())
            .then(
            (result) => {
                setIsLoaded(true);
                setTournamentsTypes(result.payLoad);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                setIsLoaded(true);
                setError(error);
            }
            )
    }, [])

    function toggleModal() {
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function validateRanking(ranking, participants) {
        // console.warn('ranking da validare:', ranking);
        // console.warn('participants:', participants);
        if (!ranking || ranking.length === 0) {
            return false;
        }
        const topN = (participants >= 410) ? 32 : (participants >= 129) ? 16 : 8;
        const topNtoCheck = (topN < ranking.length ? topN : ranking.length);
        // console.warn('how many participants i check?', topNtoCheck);
        for (let i = 0; i < topNtoCheck; i++) {
            // console.warn('participant with rank', i, ':', ranking[i]);
            if (ranking[i].deckName === '' || ranking[i].deckName === null || ranking[i].deckName === undefined) {
                return false;
            }
        }
        return true;
    }

    function handleCancel() {
        setIsActive(false);
        form.resetFields();
    }

    function onFinish(values) {
        form.validateFields({ validateOnly: true })
        .then(async () => {
            const tournament = props.tournament;
            tournament.decklist = values.decklist;
            tournament.multiplier.id = values.multiplier;
            tournament.playerAttendancy = values.participants;
            tournament.playerCap = values.playerCap;
            tournament.turns = values.turns;
            tournament.type.id = values.type;
            if ((values.type >= 1 && values.type <=3) || values.type == 14) {
            tournament.turns = 3;
            }
            tournament.isDone = values.isDone;
            tournament.canUploadDecklist = values.canUploadDecklist
            tournament.name = values.name;
            tournament.date = values.date;
            // console.warn('Form values:', values);

            if (values.isDone && (values.turns === 0 || values.participants === 0 || values.multiplier === 0)) {
                // console.warn('Form values not valid!', values);
                throw new Error('Form values not valid.');
            }

            let isRankingValid = validateRanking(props.ranking, values.participants);
            if (values.isDone && !isRankingValid) {
                // console.warn('Ranking not valid!', props.ranking);
                const errorInfo = (values.participants >= 410) ? '32' : (values.participants >= 129) ? '16' : '8';
                throw new Error('Ranking not valid. Maybe you forgot to insert the archetypes for the top ' + errorInfo + ' players?');
            }

            setConfirmLoading(true);
            const response = await fetch(api.tournaments().update().href, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Setting.getToken(),
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(tournament) // body data type must match "Content-Type" header
            })
            .then((data) => data.json())

            if (response.errorMsg === "") {
                window.location.reload(false);
            } else {
                setConfirmLoading(false);
                messageApi.error("You do not have the permission to edit this tournament status! Check the inserted infos.");
            } 
        })
        .catch((errorInfo) => {
            // console.warn('errorInfo:', errorInfo);
            messageApi.error("There is an error: " + errorInfo.message);
        })
    }

    //TODO: add isDone value to initialValues.
    return(
            <div>
                {contextHolder}
                <Modal title={t('tournaments.update')} open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} confirmLoading={confirmLoading} maskClosable={false} cancelText="Cancel" okText="Update">
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }} initialValues={{ "name": props.tournament.name, "type": (props.tournament && props.tournament.type ? props.tournament.type.id : ''), "multiplier":  (props.tournament && props.tournament.multiplier ? props.tournament.multiplier.id : 0), "participants": props.tournament.playerAttendancy, "playerCap": props.tournament.playerCap, "turns": props.tournament.turns, "date": dayjs(props.tournament.date), isDone: props.tournament.isDone, canUploadDecklist: props.tournament.canUploadDecklist }}>
                    <Form.Item label={t('tournaments.name')} name="name" >
                        <Input placeholder={t('tournaments.placeholderName')} />
                    </Form.Item>
                    <Form.Item label={t('tournaments.type')} name="type" rules={[{ required: true, message: 'Please select a type!' }]}>
                        <Select placeholder={t('tournaments.selectType')}>
                            {composeSelectOptions(tournamentTypes,{key: 'id', value: 'id', desc: 'desc'})}
                        </Select>
                    </Form.Item>    
                    <Form.Item label={t('tournaments.startDate')} name="date">
                        <DatePicker placeholder={t('tournaments.startDate')} format="DD/MM/YYYY" />
                    </Form.Item>
                    <Form.Item label={t('tournaments.split')} name="multiplier" rules={[{ required: true, message: 'Please select a value!' }]}>
                        <Select placeholder="Select option">
                            {composeSelectOptions((props.multipliers && props.multipliers.data ? props.multipliers.data.payLoad : []),{key: 'id', value: 'id', desc: 'desc'})}
                        </Select>
                    </Form.Item>
                    <Form.Item label={t('tournaments.cap')} name="playerCap">
                        <InputNumber min={8} max={1600} placeholder={t('tournaments.cap')} />
                    </Form.Item>
                    <Form.Item label={t('tournaments.participants')} name="participants" rules={[{ required: true, message: 'Please insert a value!' }]}>
                        <InputNumber min={0} max={1600} placeholder={t('tournaments.participants')} />
                    </Form.Item>
                    <Form.Item label={t('tournaments.turns')} name="turns" rules={[{ required: true, message: 'Please insert a value!' }]}>
                        <InputNumber min={3} max={15} placeholder={t('tournaments.turns')} />
                    </Form.Item>
                    <Form.Item label={t('decks.required')} name="canUploadDecklist" valuePropName="checked" tooltip={t('decks.requiredTooltip')}>
                        <Checkbox />
                    </Form.Item>
                    <Form.Item label={t('tournaments.isDone')} name="isDone" valuePropName="checked" tooltip={t('tournaments.isDoneTooltip')}>
                        <Checkbox />
                    </Form.Item>
                </Form>
                </Modal>
                <Button style={{ marginTop: 16 }} type="primary" onClick={toggleModal}>
                   {t('tournaments.update')}
                </Button>
            </div>
    )
}

export default UpdateTournament;